var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"row",attrs:{"id":"recaptcha"}},[_c('div',{staticClass:"col-12 captcha-wrapper justify-content-center"},[_c('vue-recaptcha',{ref:"recaptcha",staticClass:"recaptcha-component",attrs:{"sitekey":_vm.sitekey,"loadRecaptchaScript":true},on:{"verify":_vm.verifyEvent}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }